import { Menu, MenuItem } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { useState, useEffect } from "react";
import Languages from "services/i18n/languages";

import ArrowDown from "assets/Icons/arrowDown.svg?react";
import MDTypography from "components/MDTypography";
import i18n from "services/i18n/i18n";
import { styles } from "./SelectLanguage.styles";

import { useMaterialUIController, setDirection } from "context";

const SelectLanguage = () => {
  const [{ direction }, dispatch] = useMaterialUIController();
  const [menu, setMenu] = useState(null);
  const [selectedLang, setSelectedLang] = useState<string>(() => {
    // Initialize from i18n.language or localStorage, defaulting to "en"
    return i18n.language || localStorage.getItem("language") || "en";
  });
  const useStyles = makeStyles()((theme) => styles(theme));
  const { classes } = useStyles();

  // Listen to i18n language changes to keep the component in sync
  useEffect(() => {
    const updateLanguage = (lng: string) => {
      setSelectedLang(lng);
    };

    // Set initial language
    const currentLang = i18n.language || localStorage.getItem("language") || "en";
    setSelectedLang(currentLang);

    // Listen to language change events
    i18n.on("languageChanged", updateLanguage);

    return () => {
      i18n.off("languageChanged", updateLanguage);
    };
  }, []);

  const openMenu = (event: any) => setMenu(event.currentTarget);
  const closeMenu = () => setMenu(null);

  const onSelect = (lang: string) => {
    if (lang !== selectedLang) {
      const langDirection: "rtl" | "ltr" = Languages.find((l) => l.key === lang)
        ?.isRtl
        ? "rtl"
        : "ltr";
      // appDispatch(updateSelectedLangauge({ selectedLanguage: lang }));
      setDirection(dispatch, langDirection);
      i18n.changeLanguage(lang);
      localStorage.setItem("language", lang);
      setSelectedLang(lang);
    }
    closeMenu();
  };

  return (
    <>
      {/* <MDButton
        variant={"outlined"}
        style={{}}
        classes={{ root: classes.button }}
        onClick={openMenu}
      > */}
      <div className={classes.container} onClick={openMenu}>
        <ArrowDown />
        <MDTypography
          variant="button"
          color="black"
          marginLeft={direction === "rtl" ? "" : "8px"}
          marginRight={direction === "ltr" ? "" : "8px"}
        >
          {Languages.find((l) => l.key === selectedLang)?.label || selectedLang}
        </MDTypography>
      </div>
      {/* </MDButton> */}
      <Menu
        anchorEl={menu}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: direction === "ltr" ? "left" : "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: direction === "ltr" ? "left" : "right",
        }}
        open={Boolean(menu)}
        onClose={closeMenu}
        keepMounted
        disableAutoFocusItem
      >
        {Languages.map((lang) => (
          <MenuItem
            className={classes.menuItem}
            key={lang.key}
            onClick={() => onSelect(lang.key)}
          >
            {lang.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default SelectLanguage;
